import App from 'app/app.js';

function LtCheckOutWithPayPalButtonCtrl(TranslateProviderService) {
  this.getLocale = function () {
    return TranslateProviderService.getLocale();
  };
}

App.controller('LtCheckOutWithPayPalButtonCtrl', ['TranslateProviderService', LtCheckOutWithPayPalButtonCtrl]);
